import { LoadType } from '@tencent/ark-extensions';

export default {
    name: 'docs-component-collaboration',
    loadType: LoadType.EAGER,
};
